import { __spread } from 'tslib';
import { invariant } from 'hey-listen';
import { setValues } from '../render/utils/setters.js';
import { stopAnimation, animateVisualElement } from '../render/utils/animation.js';

function animationControls() {
  /**
   * Track whether the host component has mounted.
   */
  var hasMounted = false;
  /**
   * Pending animations that are started before a component is mounted.
   * TODO: Remove this as animations should only run in effects
   */

  var pendingAnimations = [];
  /**
   * A collection of linked component animation controls.
   */

  var subscribers = new Set();
  var controls = {
    subscribe: function subscribe(visualElement) {
      subscribers.add(visualElement);
      return function () {
        return void subscribers.delete(visualElement);
      };
    },
    start: function start(definition, transitionOverride) {
      /**
       * TODO: We only perform this hasMounted check because in Framer we used to
       * encourage the ability to start an animation within the render phase. This
       * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
       * we can ditch this.
       */
      if (hasMounted) {
        var animations_1 = [];
        subscribers.forEach(function (visualElement) {
          animations_1.push(animateVisualElement(visualElement, definition, {
            transitionOverride: transitionOverride
          }));
        });
        return Promise.all(animations_1);
      } else {
        return new Promise(function (resolve) {
          pendingAnimations.push({
            animation: [definition, transitionOverride],
            resolve: resolve
          });
        });
      }
    },
    set: function set(definition) {
      invariant(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
      return subscribers.forEach(function (visualElement) {
        setValues(visualElement, definition);
      });
    },
    stop: function stop() {
      subscribers.forEach(function (visualElement) {
        stopAnimation(visualElement);
      });
    },
    mount: function mount() {
      hasMounted = true;
      pendingAnimations.forEach(function (_a) {
        var animation = _a.animation,
            resolve = _a.resolve;
        controls.start.apply(controls, __spread(animation)).then(resolve);
      });
      return function () {
        hasMounted = false;
        controls.stop();
      };
    }
  };
  return controls;
}

function isAnimationControls(v) {
  return typeof v === "object" && typeof v.start === "function";
}

export { animationControls, isAnimationControls };